import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfIniciativasSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo
 * Conteúdo de cada card é um `object_browser` aninhado num `object_list`.
 *
 * Ver `Destaques/Data.tsx` para o porquê do `activeObject`/`setActiveObject`
 * no field spec e do re-plug do `dataAdapter` no `onChangeField`.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfIniciativasSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
